module.exports = __webpack_public_path__ + "static/media/checkbox_n.830922a9.svg";